import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Undo2 } from 'lucide-react';
import { listCreditNotes } from '../../api/creditNotes';
import { PageHeader } from '../../components/ui/PageHeader';
import { Card } from '../../components/ui/Card';
import { Table, Thead, Th, Tr, Td } from '../../components/ui/Table';
import { Spinner } from '../../components/ui/Spinner';
import { EmptyState } from '../../components/ui/EmptyState';
import { Badge } from '../../components/ui/Badge';

function money(value: string) {
  return `£${Number(value).toFixed(2)}`;
}

export function CreditNotesListPage() {
  const creditNotesQuery = useQuery({ queryKey: ['credit-notes'], queryFn: () => listCreditNotes() });

  return (
    <div>
      <PageHeader title="Credit Notes" description="Credits issued against customers, each its own numbered document." />

      <Card>
        {creditNotesQuery.isLoading ? (
          <div className="py-14 text-center">
            <Spinner />
          </div>
        ) : !creditNotesQuery.data || creditNotesQuery.data.length === 0 ? (
          <EmptyState icon={Undo2} title="No credit notes yet" description="Credit notes you issue will show up here." />
        ) : (
          <Table>
            <Thead>
              <tr>
                <Th>Credit #</Th>
                <Th>Customer</Th>
                <Th>Reason</Th>
                <Th>Total</Th>
                <Th>Status</Th>
                <Th>Issued</Th>
              </tr>
            </Thead>
            <tbody>
              {creditNotesQuery.data.map((cn) => (
                <Tr key={cn.id}>
                  <Td className="font-mono text-xs text-slate-500">
                    <Link to={`/credit-notes/${cn.id}`} className="hover:text-brand-700">
                      {cn.creditNumber}
                    </Link>
                  </Td>
                  <Td className="font-medium text-slate-900">
                    <Link to={`/credit-notes/${cn.id}`} className="hover:text-brand-700">
                      {cn.customerOrganisation?.name ?? '-'}
                    </Link>
                  </Td>
                  <Td className="max-w-xs truncate">{cn.reason}</Td>
                  <Td className="font-medium text-slate-900">{money(cn.grandTotal)}</Td>
                  <Td>
                    <Badge tone={cn.status === 'VOID' ? 'slate' : 'green'}>{cn.status}</Badge>
                  </Td>
                  <Td>{new Date(cn.generatedAt).toLocaleDateString()}</Td>
                </Tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card>
    </div>
  );
}
